module.exports = "https://coursera_assets.s3.amazonaws.com/images/47c29c0548bcd2ae439495345fb68c9d.png";